export default __webpack_public_path__ + "static/media/code_of_bar.d6bbacce.svg";